var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVitalSignFilled = function SvgVitalSignFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.117 7.367a4.687 4.687 0 0 1-1.367 3.541l-5.717 5.717A1.457 1.457 0 0 1 10 17.05c-.375 0-.75-.142-1.033-.425L3.25 10.908a3.678 3.678 0 0 1-.242-.266h3.734a.617.617 0 0 0 .475-.225l1.091-1.284 1.267 3.2c.083.209.267.35.492.384a.6.6 0 0 0 .575-.233l1.458-1.842h1.858a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625H11.8a.615.615 0 0 0-.492.241l-.975 1.225L9.092 7.7a.634.634 0 0 0-.484-.383.61.61 0 0 0-.575.216L6.45 9.392H2.233a4.768 4.768 0 0 1-.35-2.025c.059-1.334.667-2.534 1.7-3.392 1.834-1.517 4.65-1.325 6.409.433h.016c1.759-1.758 4.575-1.95 6.409-.433 1.033.858 1.641 2.058 1.7 3.392Z",
    fill: "current"
  })));
};
export default SvgVitalSignFilled;